/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var toHash = require('common/util/toHash');
var _ = require('underscore');

var SubmitEntity = require('../../entity/services/SubmitEntity');
var Constants = require('../../common/util/constants');

var tmplCreateNewEntityModalView = require('../templates/COCCreateNewEntityModalView.hbs');
var COCEntityFormView = require('../../entity/views/COCEntityFormView');

module.exports = Marionette.LayoutView.extend({
  template: tmplCreateNewEntityModalView,

  className: 'coc-create-new-entity-modal-view',

  ui: {
    entityFormContainer: '.entity-form-container',
    submit: '.btn-submit'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  regions: {
    entityFormContainer: '@ui.entityFormContainer'
  },

  initialize: function() {
    this.lookupHashes = {
      entityTypes: toHash(this.model.get('entityTypes'), 'id', 'entityType'),
      organizationTypes: toHash(this.model.get('organizationTypes'), 'id', 'organizationType')
    };
    var createEntityType = this.model.get('createEntityType');
    var entityTypes = this.model.get('entityTypes');
    if (createEntityType === Constants.VENUE) {
      entityTypes = _.filter(entityTypes, function(entityType) {
        return entityType.id === '1' || entityType.id === '3';
      });
      this.model.set('entityTypes', entityTypes);
    }
    if (createEntityType === Constants.ORGANIZATION) {
      entityTypes = _.filter(entityTypes, function(entityType) {
        return entityType.id === '2' || entityType.id === '3';
      });
      this.model.set('entityTypes', entityTypes);
    }
  },

  onBeforeShow: function() {
    this.entityForm = new COCEntityFormView({
      model: new Backbone.Model({
        entityTypes: this.model.get('entityTypes'),
        organizationTypes: this.model.get('organizationTypes')
      })
    });
    this.showChildView('entityFormContainer', this.entityForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submit.get(0));
        laddaContext.start();
        SubmitEntity(self.getFormData(), self.lookupHashes).done(function(newEntity) {
          self.triggerMethod('modal:close', newEntity);
        });
      }.bind(this)
    );
  },

  validate: function() {
    return this.ui.entityFormContainer.parsley().whenValidate();
  },

  getFormData: function() {
    return this.entityForm.getFormData();
  }
});
